import {
  applicationFilePath,
  applicationsBucket,
  APPLICATION_FILE_TYPES,
  type ApplicationFileExtension,
  type ApplicationFileKind
} from "@/components/forms/applicationFiles.shared";
import { getFirebase } from "./firebase";

/**
 * Upload an applicant's CV or letter to `applications/<formId>/` in the portal
 * bucket, where `backend/storage.portal.rules` lets anyone create (never read)
 * a PDF or .docx of up to 10 MB. Firebase Storage is loaded only here, when
 * someone actually sends an application, so no other page pays for it.
 */
export async function uploadApplicationFile(params: {
  formId: string;
  kind: ApplicationFileKind;
  extension: ApplicationFileExtension;
  file: File;
}): Promise<void> {
  const fb = getFirebase();
  const projectId = fb?.app.options.projectId;
  if (!fb || !projectId) throw new Error("Firebase is not configured");
  const { getStorage, ref, uploadBytes } = await import("firebase/storage");
  const storage = getStorage(fb.app, `gs://${applicationsBucket(projectId)}`);
  await uploadBytes(
    ref(
      storage,
      applicationFilePath(params.formId, params.kind, params.extension)
    ),
    params.file,
    { contentType: APPLICATION_FILE_TYPES[params.extension] }
  );
}
